import * as Haptics from 'expo-haptics'
import { isWeb } from '../constants/platform'

export const performHaptics = async () => {
    if (isWeb) return

    await Haptics.impactAsync(Haptics.ImpactFeedbackStyle.Light)
}
